import { Components, Theme } from '@mui/material/styles';

export const button = (theme: Theme): Components['MuiButton'] => ({
  defaultProps: {
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      display: 'inline-flex',
      width: 'auto',
      minWidth: 'unset',
      maxWidth: 'max-content',
      boxSizing: 'border-box',
      flex: '0 0 auto',
      padding: '12px 24px',
      borderRadius: 8,
      fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
      fontSize: '14px',
      lineHeight: 1.2,
      fontWeight: 700,
      letterSpacing: '-0.2px',
      textTransform: 'none',
      [theme.breakpoints.down('sm')]: {
        padding: '8px 10px',
        fontSize: '13px',
        borderRadius: 6,
      },
      '&.MuiButton-fullWidth': {
        width: '100%',
        maxWidth: '100%',
      },

      '& .MuiButtonBase-root': {},

      '& > span': {
        padding: 0,
      },
    },

    contained: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
      },
      '&.Mui-disabled': {
        backgroundColor: theme.palette.grey.additionalGrey,
        color: 'rgba(0,0,0,0.26)',
      },
    },

    outlined: {
      backgroundColor: 'transparent',
      color: theme.palette.primary.main,
      border: '1.5px solid',
      borderColor: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main,
        border: `1.5px solid`,
        borderColor: theme.palette.primary.main,
        backgroundColor: 'transparent',
      },
    },

    text: {
      padding: '4px 6px',
    },

    sizeSmall: {
      padding: '8px 10px',
      fontSize: '13px',
    },
    sizeLarge: {
      padding: '10px 18px',
    },
  },
});
